import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiMail } from 'react-icons/fi';

export const MenuItemNotifyProvider = (props: {
  course: ICourse,
  onRemindProvider: (course: ICourse) => void;
}) => {

  return (
    <>
      <MenuItem icon={<FiMail />} onClick={() => props.onRemindProvider(props.course)} >Remind Provider...</MenuItem>
    </>
  )
}
